export const getOperatorUser = state => state.operatorUserSelector.operatorUser.nodes;
export const getCheckedOperatorUser = state => state.operatorUserSelector.operatorUser.checkedOperatorUser;

export const getSelectedOperatorUser = state =>
  state.operatorUserSelector.operatorUser.nodes
    .map(node => ({
      ...node,
      children: node.children.filter(child =>
        state.operatorUserSelector.operatorUser.checkedOperatorUser
          .includes(child.value)),
    }))
    .filter(node => node.children && node.children.length);

export const getCheckedOperatorUserLabels = state =>
  getSelectedOperatorUser(state).map(node => node.label);

export const getExpandedOperatorUser =
  state => state.operatorUserSelector.operatorUser.expandedOperatorUser;
